import maplibregl from 'maplibre-gl';

export function setupPopups(map, layer) {
  if (typeof layer !== 'string') {
    console.warn('Invalid popup layer ID passed to setupPopups:', layer);
    return;
  }

  if (!map.getLayer(layer)) {
    console.warn(`Popup layer "${layer}" not found on the map.`);
    return;
  }

  const popup = new maplibregl.Popup({
    closeButton: false,
    closeOnClick: false,
  });

  function popupHover(e) {
    if (!e.features || !e.features.length) return;

    map.getCanvas().style.cursor = 'pointer';

    const coordinates = e.features[0].geometry.coordinates.slice();
    const description = e.features[0].properties.Community_;

    // Handle antimeridian crossing
    while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
      coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
    }

    popup.setLngLat(coordinates).setHTML(description).addTo(map);
  }

  function popupHoverAway() {
    popup.remove();
    map.getCanvas().style.cursor = 'default';
  }

  map.on('mouseenter', layer, popupHover);
  map.on('mouseleave', layer, popupHoverAway);
}
